export { ResultList } from './ResultList';
export type { ResultListItem } from './ResultList.types';
